import { required, image, size } from '@validations'
import TicketService from '@/services/apis/tickets'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { resizeImage } from '@/utils'

const { getTicketsById, sendTicketAnswer, closeTicketById } = new TicketService()

export default {
  components: {
    FeatherIcon,
  },
  data() {
    return {
      show: true,
      isLoading: false,
      closeLoading: false,
      required,
      image,
      size,
      ticketData: {},
      form: {
        answer: '',
        file: null,
      },
    }
  },
  computed: {
    MAX_IMAGE_UPLOAD_SIZE() {
      return process.env.VUE_APP_MAX_IMAGE_UPLOAD_SIZE
    },
  },

  mounted() {
    this.getTicketsById()
  },

  methods: {
    async onSubmitAnswer() {
      this.isLoading = true

      const compressedFile = this.form.file ? await resizeImage(this.form.file) : null
      const answerTicket = {
        context: this.form.answer,
        file: compressedFile,
      }

      sendTicketAnswer({ id: this.ticketData.id, answerTicket })
        .then(({ data }) => {
          this.getTicketsById()
          this.$swal({
            title: data?.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.form.answer = ''
          this.form.file = null
          this.$refs.form.reset()
          this.$router.push({ name: 'tickets' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    getTicketsById() {
      getTicketsById(this.$route.params.id)
        .then(({ data }) => {
          this.ticketData = data.results
        })
        .finally(() => {
          this.show = false
        })
    },

    closeTicket() {
      this.closeLoading = true
      closeTicketById(this.ticketData.id)
        .then(({ data }) => {
          this.$router.push({ name: 'tickets' })
          this.$swal({
            title: data?.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
        })
        .finally(() => {
          this.closeLoading = false
        })
    },
  },
}
